import { buildVenueAnalysisStreamSlice } from 'widgets/venueAnalysis/store/stream/streamSlice';

const { selectors: venueExecCapsuleStreamedDataSelectors } =
    buildVenueAnalysisStreamSlice();

export { venueExecCapsuleStreamedDataSelectors };
